module.exports = __webpack_public_path__ + "09_mustache_brown.03f140a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/09_mustache_brown.png
// module id = 1N9x
// module chunks = 0